import { ICardPreviewProps } from './types';
import { CLASS_PREVIEW } from '../../../constants';
import {
    PREVIEW_CARD_ATTACHMENTS_COUNT,
    PREVIEW_CARD_CHECKLIST_COMMENTS_COUNT,
    PREVIEW_CARD_CHECKLIST_ITEMS_COUNT,
    PREVIEW_CARD_COLOR_TAGS,
    PREVIEW_CARD_DONE_CHECKLIST_ITEMS_COUNT,
    PREVIEW_CARD_DONE_PERCENT,
    PREVIEW_CARD_DUE_DATE,
    PREVIEW_CARD_ESTIMATE,
    PREVIEW_CARD_LAST_ACTIVITY,
    PREVIEW_CARD_NAME,
    PREVIEW_CARD_NUMBER,
    PREVIEW_CARD_START_DATE,
    PREVIEW_CARD_SUBCARDS_COUNT,
    PREVIEW_CARD_TAGS
} from './constants';
import * as React from 'react';
import { ColorTags } from '../../../../../base/components/ColorTags/ColorTags';
import { CardProgress } from '../../../../../base/components/CardProgress/components/CardProgress';
import { ECardProgressSize } from '../../../../../base/components/CardProgress/components/types';
import { CardAgingIndicator } from '../../../../../main/kanbanView/components/CardAgingIndicator/CardAgingIndicator';
import { ECardAgingIndicatorType } from '../../../../../../../types/rest/ICardAging';
import { CardNumber } from '../../../../../main/kanbanView/components/CardNumber/CardNumber';
import { CardTags } from '../../../../../main/kanbanView/components/CardTags/components/CardTags/CardTags';
import {
    DescriptionIndicator
} from '../../../../../main/kanbanView/components/DescriptionIndicator/DescriptionIndicator';
import {
    SubCardsCountIndicator
} from '../../../../../main/kanbanView/components/subcardsCountIndicator/SubCardsCountIndicator';
import {
    SubCardIndicator
} from '../../../../../main/kanbanView/components/subCardIndicator/components/SubCardIndicator';
import {
    CommentCountIndicator
} from '../../../../../main/kanbanView/components/CommentCoundIndicator/CommentCountIndicator';
import {
    AttachmentsCountIndicator
} from '../../../../../main/kanbanView/components/AttachmentsCountIndicator/AttachmentsCountIndicator';
import {
    ChecklistsCountIndicator
} from '../../../../../main/kanbanView/components/ChecklistsCountIndicator/ChecklistsCountIndicator';
import { UsersTooltip } from '../../../../../base/components/UsersTooltip/UsersTooltip';
import { Icon } from 'kui';
import { EKanbanCardProperty } from '../../../../../../../types/types';
import './_CardPreview.scss';

export const CardPreview = ({
    activeSettings,
    assignees,
    authUserPermissionId,
    boardUsers,
}: ICardPreviewProps) => {
    const className = CLASS_PREVIEW + '-card';
    const classIndicator = className + '__indicator';

    const isShowIcons = !activeSettings.includes(EKanbanCardProperty.ESTIMATE);

    return <div className={className + '__container'}>
        <div className={className}>
            {activeSettings.includes(EKanbanCardProperty.COLOR_LABELS) &&
                <ColorTags colorTags={PREVIEW_CARD_COLOR_TAGS} size={24} />
            }
            <Icon className={className + '__more'} xlink={'more'} size={24} />
            <div className={className + '__title'}>
                {activeSettings.includes(EKanbanCardProperty.PROGRESS) &&
                    <CardProgress
                        progress={PREVIEW_CARD_DONE_PERCENT}
                        size={ECardProgressSize.BASE}
                        tooltip={''}
                        isLightBgStroke
                    />
                }
                {activeSettings.includes(EKanbanCardProperty.AGING) &&
                    <CardAgingIndicator type={ECardAgingIndicatorType.BY_ACTIVITY} date={PREVIEW_CARD_LAST_ACTIVITY} />
                }
                {activeSettings.includes(EKanbanCardProperty.PREFIXES) && <CardNumber number={PREVIEW_CARD_NUMBER} />}
                <span className={className + '__name'}>{PREVIEW_CARD_NAME}</span>
            </div>
            {activeSettings.includes(EKanbanCardProperty.TAGS) && <CardTags tags={PREVIEW_CARD_TAGS} />}
            {activeSettings.includes(EKanbanCardProperty.COUNTERS) &&
                <div className={className + '__counters'}>
                    <DescriptionIndicator/>
                    <SubCardsCountIndicator subCardsCount={PREVIEW_CARD_SUBCARDS_COUNT}/>
                    <SubCardIndicator epicName={''}/>
                    <CommentCountIndicator commentsCount={PREVIEW_CARD_CHECKLIST_COMMENTS_COUNT}/>
                    <AttachmentsCountIndicator attachmentsCount={PREVIEW_CARD_ATTACHMENTS_COUNT}/>
                    <ChecklistsCountIndicator
                        doneChecklistsCount={PREVIEW_CARD_DONE_CHECKLIST_ITEMS_COUNT}
                        checklistsCount={PREVIEW_CARD_CHECKLIST_ITEMS_COUNT}
                    />
                </div>
            }
            <div className={className + '__actions'}>
                {activeSettings.includes(EKanbanCardProperty.START_DATE) &&
                    <div className={classIndicator}>
                        {isShowIcons && <Icon size={16} xlink={'start-date'} />}
                        {PREVIEW_CARD_START_DATE}
                    </div>
                }
                {activeSettings.includes(EKanbanCardProperty.DUE_DATE) &&
                    <div className={`${classIndicator} ${classIndicator}--due`}>
                        {isShowIcons && <Icon size={16} xlink={'due-date'} />}
                        {PREVIEW_CARD_DUE_DATE}
                    </div>
                }
                {activeSettings.includes(EKanbanCardProperty.ESTIMATE) &&
                    <div className={classIndicator}>{PREVIEW_CARD_ESTIMATE}</div>
                }
                {activeSettings.includes(EKanbanCardProperty.PRIORITY) &&
                    <Icon
                        className={className + '__priority'}
                        size={24}
                        xlink={'priority-medium'}
                    />
                }
                {activeSettings.includes(EKanbanCardProperty.ASSIGNEES) &&
                    <UsersTooltip
                        authUserPermissionId={authUserPermissionId}
                        isBig
                        users={assignees}
                        boardUsers={boardUsers}
                    />
                }
            </div>
        </div>
    </div>;
}
